import React, { useState } from 'react';
import logo from '../assets/Images/wglogo.svg'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Square from "./SquareCards";
// import { Button } from "@material-tailwind/react";

const LineButton = (props) => {
  const navigate = useNavigate();
  const classes = "primary"
  const combinedClasses = `${classes} ${props.className}`;
  const [red, setRed] = useState(true);
  const [green, setGreen] = useState(false);
  const [yellow, setYellow] = useState(false);
  const location = useLocation();
  const { pathname } = location;

  function showGreen() {
    setRed(false);
    setYellow(false);
    setGreen(true);
  } function showGreenNavigate() {
    navigate('/services')
    setRed(false);
    setYellow(false);
    setGreen(true);
  }
  function showRed() {
    setRed(true);
    setYellow(false);
    setGreen(false);
  } function showRedNavigate() {
    navigate('/services')

    setRed(true);
    setYellow(false);
    setGreen(false);
  }
  function showYellow() {
    setYellow(true);
    setGreen(false);
    setRed(false);
  } function showYellowNavigate() {
    navigate('/services')
    setYellow(true);
    setGreen(false);
    setRed(false);
  }

  const redClass = pathname !== '/' && red ? 'text-black text-center  MouseCursor bg-transparent service-head displayFont bolder w-25' : 'text-black text-center MouseCursor displayFont service-head w-25';
  const greenClass = pathname !== '/' && green ? 'text-black text-center service-head  MouseCursor bolder displayFont w-25' : 'text-black text-center service-head MouseCursor displayFont w-25';
  const yellowClass = pathname !== '/' && yellow ? 'text-black text-center service-head bg-transparent MouseCursor displayFont  bolder w-25' : 'text-black text-center service-head displayFont MouseCursor w-25';
  const cursorMode = 'MouseCursor';

  return (

    <>

      <section className={'d-flex flex-row mt-5 flex-wrap justify-content-around'}>
        <div>
          <p className={'bebas text-black display-2 Number-Font '}>
            1
          </p>
        </div>
        <div>
          <p className={' bebas text-black display-2 Number-Font '}>
            2
          </p>
        </div>
        <div>
          <p className={'bebas text-black display-2 Number-Font '}>
            3
          </p>
        </div>
      </section>

      <hr size={'5'} color='black' />

      <div className={'d-flex flex-row flex-wrap justify-content-around'}>
        <h5 style={red && pathname !== '/' ? { fontWeight: '500' } : null} onClick={pathname !== '/' ? showRed : showRedNavigate} className={redClass}>
          Cybersecurity Benchmarking
        </h5>
        <h5 style={green ? { fontWeight: '500' } : null} onClick={pathname !== '/' ? showGreen : showGreenNavigate} className={greenClass}>
          Regulations & Standards
        </h5>
        <h5 style={yellow ? { fontWeight: '500' } : null} onClick={pathname !== '/' ? showYellow : showYellowNavigate} className={yellowClass}>
          Cybersecurity Managed Services
        </h5>
      </div>


      {pathname !== '/' ? red ?
        <>

          <div style={{ transition: 'all  0.3s ease' }} className={'d-flex mb-5 mt-5 flex-row justify-content-center align-items-center flex-wrap'}>


              <Square to={'/services/penetration'} className={'mx-4  cardRed mt-5'} Title={"Penetration testing"} text={'Our Red Team conduct a series of technical assessments on your organization’s security controls to discover the weakness of network infrastructure, operating systems, databases, and software application.\n' +
                '\n'} />
              {/*// 'Our team will use various tools and techniques to find unintended services made publicly available by your network and we also apply real-world attacker approaches to highlight unknown vulnerabilities on the given scope.'}  />*/}

              <Square to={'/services/red-team'} className={'mx-4 mt-5 cardRed '} Title={'Red Team Assessment'} text={'Our Red Team use nondestructive methods to test\n' +
                  'your ability to detect and respond to an active attacker scenario. The goal\n' +
                  'of this service is to assess your security controls, prepare for future attacks,\n' +
                  'mitigate the risk of costly security breaches, reduce your response time to\n' +
                  'attacks and provide practical recommendations for improving your\n' +
                  'security posture.'} />

              <Square to={'/services/vulnerability'} className={'mx-4 mt-5 cardRed '} Title={"Vulnerability Assessment"} text={' Our Red Team Perform detailed Vulnerability\n' +
                  'Assessments on all technical layers of your organization, from operating\n' +
                  'systems, web applications to network devices, and classifies all\n' +
                  'discovered vulnerabilities according to risk level and severity.\n' +
                  'The results of Vulnerability Assessments performed by our experts will help\n' +
                  'your organization develop an asset-aware security road map according\n' +
                  'to which IT assets require immediate action.'} />


              <Square to={'/services/code-review'} className={'mx-4 mt-5 cardRed '} Title={"Source Code Review"} text={'Our Red Team ensure that your application goes\n' +
                  'under thorough analysis to discover security issues that can be easily\n' +
                  'missed during the regular black box or even grey box penetration tests.\n' +
                  'We have developed our own testing methodology that implements a\n' +
                  'hybrid approach using a combination of high end automated tools and\n' +
                  'exhaustive manual inspection to spot the light on the hard to find security\n' +
                  'vulnerabilities and improve the security posture of your application.'} />
              <Square to={'/services/digital-forensics'} className={'mx-4 mt-5 cardRed '} Title={"Digital Forensics"} text={'Is an umbrella term referring to methodological\n' +
                  'investigations into alleged criminal use, fraud or theft on all digital devices,\n' +
                  'services and infrastructure.'} />
              <Square to={'/services/security-awareness'} className={'mx-4 mt-5 cardRed '} Title={"Security Awareness Training"} text={'Is a strategy used by IT and security\n' +
                  'professionals to prevent and mitigate user risk. These programs are\n' +
                  'designed to help users and employees understand the role they play in\n' +
                  'helping to combat information security breaches. Effective security\n' +
                  'awareness training helps employees understand proper cyber hygiene,\n' +
                  'the security risks associated with their actions and to identify cyber\n' +
                  'attacks they may encounter via email and the web.'} />
              <Square to={'/services/threat-haunting'} className={'mx-4 mt-5 cardRed '} Title={"Threat Haunting & Data Breach Monitoring"} text={'Threat Hunting is a forward looking approach to internet security in\n' +
                  'which threat hunters proactively search for security risks concealed within\n' +
                  'an organization’s network. Unlike more passive cyber security hunting\n' +
                  'strategies like automated threat detection systems, cyber hunting actively\n' +
                  'seeks out previously undetected, unknown, or non-remediated threats\n' +
                  'that could have evaded your network’s automated defense systems...\n' +
                  '                        '} />
              <Square to={'/services/incident-response'} className={'mx-4 mt-5 cardRed '} Title={"Incident Response And Handling"} text={'Is an organized, strategic approach to detecting and\n' +
                  'managing cyber attacks in ways that minimize damage, recovery time\n' +
                  'and total costs.'} />

              <Square to={'/services/business-continuity'} className={'mx-4 mt-5 cardRed '} Title={"Business Continuity And Recovery"} text={'Is about having a plan to deal with\n' +
                  'difficult situations, so your organization can continue to function with as\n' +
                  'little disruption as possible.\n' +
                  'Whether it’s a business, public sector organization, or charity, you need to\n' +
                  'know how you can keep going under any circumstances.'} />

              {/*<Square to={'/services/soc'} className={'mx-4 mt-5 cardRed '} Title={"SOC As A Service"} text={'Our Security Operations Centre (SOC-as-a-Service)\n' +*/}
              {/*    'provides innovative, advanced managed threat detection and incident\n' +*/}
              {/*    'response solutions to protect your business from emerging cyber threats\n' +*/}
              {/*    'while ensuring regulatory compliance and reducing the cost of managing\n' +*/}
              {/*    'and operating the Security Operations Centre.'} />*/}

              {/*<Square to={'/services/grc'} className={'mx-4 mt-5 cardRed '} Title={"GRC As A Service"} text={'Governance, Risk and Compliance as a Service is new\n' +*/}
              {/*    'offering designed carefully for our customers to reduce GRC operations\n' +*/}
              {/*    'cost and build a mature GRC department that aligned with your business\n' +*/}
              {/*    'strategy and objectives . GRC as a Service is a unique service that allows\n' +*/}
              {/*    'our customers to leverage the benefits of our experienced and trained\n' +*/}
              {/*    'GRC consultants that implement, enhance and manage your GRC\n' +*/}
              {/*    'environment.'} />*/}
              {/*<Square to={'/services/manage-bug'} className={'mx-4 mt-5 cardRed '} Title={"Manage Bug Bounty Programs"} text={'Is an enterprise security program that\n' +*/}
              {/*    'connects with a community of experts to find vulnerabilities in products\n' +*/}
              {/*    'such as websites, applications, network, API. For each bug found, the\n' +*/}
              {/*    'business will award a bounty, swag or hall of fame to the bug hunter. This\n' +*/}
              {/*    'is a security model that has received a lot of attention from organizations\n' +*/}
              {/*    'and businesses today because of its efficiency and cost optimization.'} />*/}

            {/*<Link className={'text-decoration-none'} to={'/services/penetration'}>*!/*/}
            {/*  <Square className={'mx-4 mt-5 cardRed '} Title={"Penetration testing"} text={'Some quick example text to build on the card title and make up the\n' +*/}
            {/*    '          bulk of the card\'s content.'} />*/}
            {/*</Link><Link className={'text-decoration-none'} to={'/services/penetration'}>*/}
            {/*  <Square className={'mx-4 mt-5 cardRed '} Title={"Penetration testing"} text={'Some quick example text to build on the card title and make up the\n' +*/}
            {/*    '          bulk of the card\'s content.'} />*/}
            {/*</Link>*/}
          </div>
        </> : null : null
      }
      {
        pathname !== '/' ? green ?
          // to={'/services/mobile'}

          <><div className={'d-flex mt-5 mb-5 flex-row flex-wrap justify-content-center'}>
              <Square className={'mx-4 mt-5 cardGreen '} Title={"PCI-DSS / Pin Sec"} text={'Assessment includes review of the cardholder environment and\n' +
                  'production network (including vulnerability and penetration testing)\n' +
                  'and supporting technical documentation, & stakeholders\' interviews.\n' +
                  'We also provide PCI-DSS Compliance Support Service which is deigned\n' +
                  'carefully to provide further support and meet your requirements.'} />
              <Square className={'mx-4 mt-5 cardGreen '} Title={"ISO/IEC 27000-Series"} text={'With ISO/IEC 27001:2013 certification you can show\n' +
                  'to existing and potential customers, suppliers and shareholders the\n' +
                  'integrity of your data and systems and your commitment to information\n' +
                  'security. Our experts can help you comply with the ISO/IEC 27001:2013\n' +
                  'standard efficiently and cost effectively.'} />
              <Square className={'mx-4 mt-5 cardGreen '} Title={"HIPPA"} text={'laws are a series of federal regulatory standards that outline the\n' +
                  'lawful use and disclosure of protected health information in the United\n' +
                  'States. HIPAA compliance is regulated by the Department of Health and\n' +
                  'Human Services (HHS) and enforced by the Office for Civil Rights (OCR).\n' +
                  'HIPAA compliance is a living culture that health care organisations must\n' +
                  'implement within their business in order to protect the privacy, security,\n' +
                  'and integrity of protected health information'} />

              <Square className={'mx-4 mt-5 cardGreen '} Title={"GDPR"} text={'is an EU data protection law that came into effect on 25 May 2018.\n' +
                  'means that an organisation has taken steps to ensure they are meeting\n' +
                  'the requirements of the General Data Protection Regulation (GDPR).\n' +
                  'GDPR compliance involves implementing processes and procedures to\n' +
                  'protect the personal data of EU citizens, such as ensuring that data is\n' +
                  'collected and stored securely, informing individuals of how their data is\n' +
                  'being used, and allowing individuals to see, amend, or delete their data.'} />
              <Square className={'mx-4 mt-5 cardGreen '} Title={"IoT"} text={''} />

          </div>
          </>
          : null : null
      }
      {
        pathname !== '/' ? yellow ?
          <>
            {/* to={'/services/yellow'} */}

            <div className={'d-flex mt-5 mb-5 flex-row flex-wrap justify-content-center'}>
                <Square to={'/services/soc'} className={'mx-4 mt-5 cardYellow '} Title={"SOC as a service"} text={' Our Security Operations Centre (SOC-as-a-Service)\n' +
                    'provides innovative, advanced managed threat detection and incident\n' +
                    'response solutions to protect your business from emerging cyber threats\n' +
                    'while ensuring regulatory compliance and reducing the cost of managing\n' +
                    'and operating the Security Operations Centre.'} />
                <Square to={'/services/grc'} className={'mx-4 mt-5 cardYellow '} Title={"GRC as a service"} text={'Governance, Risk and Compliance as a Service is new\n' +
                    'offering designed carefully for our customers to reduce GRC operations\n' +
                    'cost and build a mature GRC department that aligned with your business\n' +
                    'strategy and objectives . GRC as a Service is a unique service that allows\n' +
                    'our customers to leverage the benefits of our experienced and trained\n' +
                    'GRC consultants that implement, enhance and manage your GRC\n' +
                    'environment.\n'} />
                <Square to={'/services/manage-bug'} className={'mx-4 mt-5 cardYellow '} Title={"Manage Bug Bounty Programs"} text={'is an enterprise security program that\n' +
                    'connects with a community of experts to find vulnerabilities in products\n' +
                    'such as websites, applications, network, API. For each bug found, the\n' +
                    'business will award a bounty, swag or hall of fame to the bug hunter. This\n' +
                    'is a security model that has received a lot of attention from organizations\n' +
                    'and businesses today because of its efficiency and cost optimization.'} />

            </div>
          </> : null : null
      }



    </>



  );

}

export default LineButton;